module.exports = __webpack_public_path__ + "img/render-1.ca0986ec.jpg";